import { UsersInShopTableBodyLineProps } from './users-in-shop-table-body-line.types'
import styles from './users-in-shop-table-body-line.module.scss'
import cl from 'classnames'
import {
  Button,
  TableBodyLine,
} from '@touche-lts/panel-ui/dist'
import { usersInStoreTableWidths } from '../users-in-shop-table.utils'
import { PictureNameLine } from 'components/common'
import { getUserFullName, UsersInStoreTableSortProps } from 'mobx-stores'
import moment from 'moment'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useState } from 'react'

const UsersInShopTableBodyLineComponent = (
  props: UsersInShopTableBodyLineProps
) => {
  const { className, style, user, onRemoveClick } = props
  const {
    usersInStoreTableStore: { isColumnMarked },
    routingStore: { push }
  } = useRootStore()
  const [mouseOver, setMouseOver] = useState<boolean>(false)

  return (
    <TableBodyLine
      key={user.id}
      className={className}
      style={style}
      onMouseEnter={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}
      cells={[
        {
          widthPx: usersInStoreTableWidths.user,
          isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.NAME),
          children: (
            <PictureNameLine
              imageSrc={user.imageUrl}
              name={getUserFullName(user)}
            />
          ),
          onClick: () => push(`/user-management/${user.id}`)
        },
        {
          widthPx: usersInStoreTableWidths.role,
          isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.ROLE),
          children: user.role.label
        },
        {
          // widthPercentage: 100,
          widthPx: usersInStoreTableWidths.assignStore,
          isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.DATE),
          children: (
            <>
              {moment(user.created).format('DD.MM.YYYY')}
              <Button
                preset='link'
                className={cl(styles.removeButton, {
                  [styles.fullOpacity]: mouseOver
                })}
                onClick={onRemoveClick}
                title='Remove user from store'
              >
                Remove
              </Button>
            </>
          )
        }
      ]}
    />
  )
}

const UsersInShopTableBodyLine = observer(UsersInShopTableBodyLineComponent)
export { UsersInShopTableBodyLine }
